// Site-wide constants for Floreal Atelier del Fiore
export const SITE = {
    name: 'Floreal Atelier del Fiore',
    shortName: 'Floreal',
    tagline: 'Fiori, piante, matrimoni, workshop e allestimenti su misura a Lomazzo.',
    logoUrl: 'https://customer-assets.emergentagent.com/job_floreal-como/artifacts/x2mnmvne_Untitled%20design.png',
    sinceYear: 1988,
    address: 'Via Unione, 3 — 22074 Lomazzo (CO)',
    addressLines: ['Via Unione, 3', '22074 Lomazzo (CO)'],
    phones: [
        { label: 'Negozio', value: '02 9677 9924', tel: '+390296779924' },
        { label: 'Mobile', value: '338 498 4512', tel: '+393384984512' },
    ],
    email: 'contact@florealworld.it',
    hours: [
        { label: 'Martedì — Sabato', value: '9:30 – 12:00  |  16:00 – 19:00' },
        { label: 'Domenica e Lunedì', value: 'Chiuso' },
    ],
    whatsappNumber: '+390296779924',
    whatsappUrl: 'https://wa.me/390296779924',
    instagramUrl: 'https://www.instagram.com/floreal_lomazzo',
    instagramHandle: '@floreal_lomazzo',
    googleMapsUrl: 'https://maps.google.com/?q=Via+Unione+3,+22074+Lomazzo+CO',
    googleMapsEmbedSrc: 'https://www.google.com/maps?q=Via%20Unione%203%2C%2022074%20Lomazzo%20CO&output=embed',
};

export const SERVICE_CARDS = [
    {
        id: 'matrimoni',
        title: 'Matrimoni',
        excerpt: 'Bouquet, allestimenti cerimonia e ricevimento, centrotavola, auto sposi. Un percorso curato dalla prima consulenza al giorno del sì.',
        details: [
            'Bouquet da sposa e bottoniere',
            'Allestimento cerimonia',
            'Allestimento ricevimento',
            'Centrotavola e dettagli',
            'Auto sposi',
            'Sopralluogo e consulenza',
        ],
        category: 'matrimoni',
    },
    {
        id: 'eventi-privati',
        title: 'Eventi privati',
        excerpt: 'Compleanni, anniversari, cene a tema. Atmosfere costruite intorno alle persone.',
        category: 'eventi',
    },
    {
        id: 'eventi-aziendali',
        title: 'Eventi aziendali',
        excerpt: 'Inaugurazioni, vetrine, gala, allestimenti per uffici e showroom.',
        category: 'eventi',
    },
    {
        id: 'bouquet',
        title: 'Bouquet e composizioni',
        excerpt: 'Mazzi e composizioni d’autore per ogni occasione, freschezza e stagionalità.',
        category: 'bouquet',
    },
    {
        id: 'piante-giardini',
        title: 'Piante e giardini',
        excerpt: 'Piante d’interno e d’esterno, progettazione di piccoli giardini e terrazzi.',
        category: 'giardini',
    },
    {
        id: 'workshop',
        title: 'Workshop floreali',
        excerpt: 'Esperienze in atelier per imparare gesti, tecniche e composizioni. Materiali inclusi.',
        category: 'workshop',
    },
    {
        id: 'consegne',
        title: 'Consegne a domicilio',
        excerpt: 'Consegne a Lomazzo e nei comuni limitrofi. Composizioni personalizzate, su richiesta.',
        category: 'bouquet',
    },
];

export const GALLERY_FILTERS = [
    { id: 'all', label: 'Tutti' },
    { id: 'atelier', label: 'Atelier' },
    { id: 'matrimoni', label: 'Matrimoni' },
    { id: 'workshop', label: 'Workshop' },
    { id: 'giardini', label: 'Giardini' },
];

export const REQUEST_TYPES = [
    { value: 'matrimonio', label: 'Matrimonio' },
    { value: 'evento_privato', label: 'Evento privato' },
    { value: 'evento_aziendale', label: 'Evento aziendale' },
    { value: 'workshop_privato', label: 'Workshop privato' },
    { value: 'allestimento', label: 'Allestimento casa / negozio' },
    { value: 'altro', label: 'Altro' },
];

export const SLOT_TIMES = [
    '10:00', '10:30', '11:00', '11:30',
    '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
];
